import { allEnumValues, KioskAvailabilityState, KioskBatteryState, KioskBluetoothState, KioskCashMachineStatus, KioskExternalTouchDisplayState, KioskNetworkInterface, KioskPaymentTerminalModel, KioskPaymentTerminalState, KioskPeripheralConnectionState, KioskPeripheralType, KioskPusherState, KioskTableTrackerStatus, KioskWifiPowerState, PrinterCoverState, PrinterPaperState, } from '@biteinc/enums';
const KioskPrinterStatusSchemaFields = {
    macAddress: {
        type: 'keyString',
        required: true,
    },
    connectionState: {
        type: 'int',
        values: allEnumValues(KioskPeripheralConnectionState),
        required: true,
    },
    paperState: {
        type: 'int',
        values: allEnumValues(PrinterPaperState),
    },
    coverState: {
        type: 'int',
        values: allEnumValues(PrinterCoverState),
    },
    disconnectedSince: {
        type: 'timestamp',
    },
    consecutiveFailedJobCount: {
        type: 'int',
    },
    peripheralStati: {
        type: 'array',
        elementType: 'object',
        fields: {
            deviceType: {
                type: 'int',
                required: true,
                values: allEnumValues(KioskPeripheralType),
            },
            macAddress: {
                type: 'keyString',
                required: true,
            },
            target: {
                type: 'keyString',
                required: true,
            },
            connectionState: {
                type: 'int',
                required: true,
                values: allEnumValues(KioskPeripheralConnectionState),
            },
            disconnectedSince: {
                type: 'timestamp',
            },
        },
    },
};
export const post = {
    method: 'POST',
    paths: ['/api/orgs/:orgId/locationId/:locationId/status'],
    fields: {
        kioskId: {
            type: 'mongoId',
            isNullable: true,
        },
        pusherChannel: {
            type: 'keyString',
        },
        pusherState: {
            type: 'int',
            values: allEnumValues(KioskPusherState),
        },
        isUsingMenu: {
            type: 'bool',
        },
        state: {
            type: 'int',
        },
        prefix: {
            type: 'keyString',
        },
        deviceStatus: {
            type: 'object',
            required: true,
            fields: {
                batteryState: {
                    type: 'int',
                    values: allEnumValues(KioskBatteryState),
                },
                batteryLevel: {
                    type: 'float',
                },
                currentNetworkInterface: {
                    type: 'int',
                    values: allEnumValues(KioskNetworkInterface),
                },
                expectedNetworkInterface: {
                    type: 'int',
                    values: allEnumValues(KioskNetworkInterface),
                },
                networkSpeedMbps: {
                    type: 'float',
                },
                ipAddress: {
                    type: 'keyString',
                },
                online: {
                    type: 'bool',
                },
                availability: {
                    type: 'int',
                    values: allEnumValues(KioskAvailabilityState),
                },
                turnedOffAt: {
                    type: 'timestamp',
                },
                downSince: {
                    type: 'timestamp',
                },
                isAsamEnabled: {
                    type: 'bool',
                },
                isSystemAsamEnabled: {
                    type: 'bool',
                },
                isVoiceOverEnabled: {
                    type: 'bool',
                },
                isHeadsetPluggedIn: {
                    type: 'bool',
                },
                uptime: {
                    type: 'int',
                    max: 1900000000000,
                    // "increasing the max to 2030-03-17 because BITE-715 happens"
                },
                enrollmentCount: {
                    type: 'int',
                },
                buildName: {
                    type: 'keyString',
                },
                buildNumber: {
                    type: 'int',
                },
                modelName: {
                    type: 'keyString',
                },
                isEloValueModel: {
                    type: 'bool',
                },
                visiblePrinterMacAddresses: {
                    type: 'array',
                    elementType: 'keyString',
                },
                visiblePrinterPeripherals: {
                    type: 'array',
                    elementType: 'keyString',
                },
                visibleUsbPeripherals: {
                    type: 'array',
                    elementType: 'keyString',
                },
                menuTimestamp: {
                    type: 'timestamp',
                },
                menuJSVersion: {
                    type: 'timestamp',
                },
                gcnVersionName: {
                    type: 'keyString',
                },
                vitrineVersionName: {
                    type: 'keyString',
                },
                garconBuildName: {
                    type: 'keyString',
                },
                brightnessLevel: {
                    type: 'float',
                },
                displayStatus: {
                    type: 'object',
                    fields: {
                        density: {
                            type: 'float',
                            required: true,
                        },
                        deviceRebootRequired: {
                            type: 'bool',
                            required: true,
                        },
                        eloDeviceDpi: {
                            type: 'int',
                        },
                        externalTouchDisplayState: {
                            type: 'stringEnum',
                            enum: KioskExternalTouchDisplayState,
                        },
                        isTouchDisplayFaulty: {
                            type: 'bool',
                        },
                    },
                },
                bluetoothState: {
                    type: 'int',
                    values: allEnumValues(KioskBluetoothState),
                },
                visibleBluetoothAccessories: {
                    type: 'array',
                    elementType: 'object',
                    fields: {
                        isConnected: {
                            type: 'bool',
                        },
                        name: {
                            type: 'keyString',
                        },
                        manufacturer: {
                            type: 'keyString',
                        },
                        modelNumber: {
                            type: 'keyString',
                        },
                        serialNumber: {
                            type: 'keyString',
                        },
                        firmwareRevision: {
                            type: 'keyString',
                        },
                        hardwareRevision: {
                            type: 'keyString',
                        },
                    },
                },
                webViewVersion: {
                    type: 'keyString',
                },
                wifiPowerState: {
                    type: 'int',
                    values: allEnumValues(KioskWifiPowerState),
                },
                wifiConnected: {
                    type: 'bool',
                },
                wifiSsid: {
                    type: 'keyString',
                },
                notificationsAuthorizationStatus: {
                    type: 'int',
                },
            },
        },
        scannerStatus: {
            type: 'object',
            fields: {
                connected: {
                    type: 'bool',
                    required: true,
                },
            },
        },
        scaleStatus: {
            type: 'object',
            fields: {
                connected: {
                    type: 'bool',
                    required: true,
                },
            },
        },
        stormAudioNavStatus: {
            type: 'object',
            fields: {
                connected: {
                    type: 'bool',
                    required: true,
                },
            },
        },
        msrStatus: {
            type: 'object',
            fields: {
                connected: {
                    type: 'bool',
                    required: true,
                },
            },
        },
        hidStatus: {
            type: 'object',
            fields: {
                connected: {
                    type: 'bool',
                    required: true,
                },
            },
        },
        paymentTerminalStatus: {
            type: 'object',
            fields: {
                type: {
                    type: 'int',
                    // TODO: remove -1 once https://getbite.atlassian.net/browse/BITE-5275 is deployed to everyone
                    values: [...allEnumValues(KioskPaymentTerminalModel), -1],
                    required: true,
                },
                state: {
                    type: 'int',
                    values: allEnumValues(KioskPaymentTerminalState),
                    required: true,
                },
                softwareVersion: {
                    type: 'keyString',
                },
                disconnectedSince: {
                    type: 'timestamp',
                },
            },
        },
        kioskPrinterStatus: {
            type: 'object',
            fields: KioskPrinterStatusSchemaFields,
        },
        kdsStatus: {
            type: 'object',
            fields: {
                connected: {
                    type: 'bool',
                    required: true,
                },
            },
        },
        tableTrackerStatus: {
            type: 'object',
            fields: {
                status: {
                    type: 'stringEnum',
                    enum: KioskTableTrackerStatus,
                    required: true,
                },
            },
        },
        posStatus: {
            type: 'object',
            fields: {
                status: {
                    type: 'keyString',
                    required: true,
                },
            },
        },
        cashMachineStatus: {
            type: 'object',
            fields: {
                status: {
                    type: 'stringEnum',
                    enum: KioskCashMachineStatus,
                    required: true,
                },
            },
        },
    },
};
//# sourceMappingURL=status_post.js.map